import { combineReducers, createReducer, on } from '@ngrx/store';
import { addAllAccounts, decrementCurrentWizardStep, incrementCurrentWizardStep, resetAccountResultsLoaded, resetCurrentWizardStep, resetSelectAllAccounts, resetSelectedAccounts, selectAccount, selectPortfolio, setAccountResultsLoaded, setImportType, setPortfolioImportType, setSearchType, toggleSelectAllAccounts, } from './import-holdings.actions';
import { BD_SEARCH_PORTFOLIO } from 'IntegrationsApp/ts/constants';
import { MODEL_PORTFOLIO } from 'ModelPortfolioApp/ts/shared/constants';
export const currentWizardStepIndex = createReducer(0, on(incrementCurrentWizardStep, (state) => {
    return state + 1;
}), on(decrementCurrentWizardStep, (state) => {
    return state - 1;
}), on(resetCurrentWizardStep, () => {
    return 0;
}));
export const searchType = createReducer(BD_SEARCH_PORTFOLIO, on(setSearchType, (state, { searchType: newSearchType }) => {
    return newSearchType;
}));
export const portfolioImportType = createReducer(MODEL_PORTFOLIO, on(setPortfolioImportType, (state, { newPortfolioImportType }) => {
    return newPortfolioImportType;
}));
export const selectedAccounts = createReducer([], on(selectAccount, (state, { selectedAccountId: newAccountId }) => {
    if (state.map((account) => account.id).includes(newAccountId)) {
        return state.filter((account) => account.id !== newAccountId);
    }
    return [...state, { id: newAccountId, importAsSingleHolding: false }];
}), on(setImportType, (state, { id, importAsSingleHolding }) => {
    if (state.map((account) => account.id).includes(id)) {
        return state.map((account) => {
            if (account.id === id) {
                return { ...account, importAsSingleHolding };
            }
            return account;
        });
    }
    return [...state, { id, importAsSingleHolding }];
}), on(resetSelectedAccounts, () => {
    return [];
}), on(addAllAccounts, (state, { accounts: serializedAccounts }) => {
    return serializedAccounts.map((account) => {
        return { id: account.id, importAsSingleHolding: false };
    });
}));
export const selectedPortfolio = createReducer(null, on(selectPortfolio, (state, { selectedPortfolio: newPortfolio }) => {
    return newPortfolio;
}));
export const selectAllAccounts = createReducer(false, on(toggleSelectAllAccounts, (state) => {
    return !state;
}), on(resetSelectAllAccounts, () => {
    return false;
}));
export const accountResultsLoaded = createReducer(false, on(setAccountResultsLoaded, (state, action) => {
    return action.loaded;
}), on(resetAccountResultsLoaded, () => {
    return false;
}));
export const blackDiamondImportHoldings = combineReducers({
    currentWizardStepIndex,
    searchType,
    selectedAccounts,
    selectedPortfolio,
    selectAllAccounts,
    portfolioImportType,
    accountResultsLoaded,
});
